import React from "react";
import NewProductc from "../components/newrelease";
import useSeo from "../services/useSeo";


function Rank(props) {
  useSeo({
    title: "最新上傳 | 琴語鋼琴網",
    description: "琴語鋼琴網最新上傳的鋼琴譜與簡譜，每日更新。",
    canonicalPath: "/ranking",
  });

  return (
      <div>
        {/* <Types /> */}
        <NewProductc limit={30}></NewProductc>
        {/* <ProductTabs /> */}
        {/* <ProductCard slides={allProducts} /> */}
        {/* <ClientCarousel /> */}
      </div>
  );

}

export default Rank;
